import React from "react";

import Grid from "@material-ui/core/Grid";
import KeyboardReturnIcon from "@material-ui/icons/KeyboardReturn";
import Button from "@material-ui/core/Button";
import { Dialog, DialogTitle, DialogContent } from "@material-ui/core";

export default function CNDFailure({ setOpenCndFailure, arrCndFailures }) {
  return (
    <>
      <Dialog
        open={true}
        onClose={() => {
          setOpenCndFailure(false);
        }}
        maxWidth="xs"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Datas das Falhas</DialogTitle>

        <DialogContent>
          {arrCndFailures.map((error, index) =>
            error.created_at ? (
              <Grid container spacing={1} key={index} justifyContent="center">
                <Grid item>
                  {new Date(error.created_at).toLocaleDateString("pt-BR", {
                    timeZone: "UTC",
                  })}
                </Grid>
              </Grid>
            ) : (
              <></>
            )
          )}

          <Grid container justify="flex-end" className="cnd-container-btns">
            <Button
              variant="contained"
              startIcon={<KeyboardReturnIcon />}
              className="cnd-btn-cancelar"
              onClick={() => setOpenCndFailure(false)}
            >
              Fechar
            </Button>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
}
